module.exports = __webpack_public_path__ + "img/menu_exit_pre.53ce494e.svg";